export default "__VITE_ASSET__ME_ORSWpfOZT8akIeCPVOQ__"